import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { NgxPermissionsService } from 'ngx-permissions';
import { BreakpointObserverHelperService } from '@src/core/services';

import { NAVIGATION_ITEMS, NavigationItem } from '../../navigation';

@Injectable({
  providedIn: 'root',
})
export class RedirectGuard {
  private readonly router = inject(Router);
  private readonly ngxPermissionsService = inject(NgxPermissionsService);
  private readonly breakpointObserverHelperService = inject(BreakpointObserverHelperService);

  async canActivate(): Promise<boolean> {
    if (this.breakpointObserverHelperService.isMobile) {
      await this.redirectToPage('/info');
    } else {
      await this.redirectToPage('/association');
    }

    return true;
  }

  private async redirectToPage(url: string) {
    const findItem = NAVIGATION_ITEMS.find(item => item.link === url);
    if (findItem) {
      await this.checkPermissionsRoute(findItem);
    }

    return await this.redirectToNextPage();
  }

  private async checkPermissionsRoute(item: NavigationItem) {
    if (item.permissions && item.link) {
      const hasPermission = await this.ngxPermissionsService.hasPermission(item.permissions);
      if (hasPermission) {
        this.router.navigate([item.link]);
        return true;
      }
    }

    return false;
  }

  private async redirectToNextPage() {
    for (const item of NAVIGATION_ITEMS) {
      if (!this.breakpointObserverHelperService.isMobile && !!item.mobileOnly) {
        // Не делаем redirect на мобильные страницы в десктопной версии
        continue;
      }

      const checkPermissions = await this.checkPermissionsRoute(item);
      if (checkPermissions) {
        return true;
      }
    }

    return false;
  }
}
